import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
import Logo from 'ui-component/Logo';
import LogoMobile from 'ui-component/LogoMobile';
import { BrowserView, MobileView } from 'react-device-detect';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={config.defaultPath}>
        <BrowserView>
            <Logo />
        </BrowserView>
        <MobileView>
            <LogoMobile />
        </MobileView>
    </ButtonBase>
);

export default LogoSection;
